import { forwardRef, type Ref, type SVGProps } from "react";
const IconCoolingFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16.027 2a2 2 0 0 1 2 2v.757l1.012-.886a1.5 1.5 0 1 1 1.975 2.258l-2.987 2.614v3.793l3.284-1.896.77-3.895a1.5 1.5 0 1 1 2.944.582l-.261 1.32.655-.38a2 2 0 0 1 2 3.465l-.655.379 1.273.433a1.5 1.5 0 1 1-.968 2.84l-3.758-1.28L20.027 16l3.284 1.896 3.758-1.28a1.5 1.5 0 0 1 .968 2.84l-1.273.434.655.378a2 2 0 0 1-2 3.464l-.655-.378.26 1.32a1.5 1.5 0 1 1-2.943.581l-.77-3.895-3.284-1.896v3.793l2.987 2.614a1.5 1.5 0 1 1-1.975 2.258l-1.012-.886V28a2 2 0 0 1-4 0v-.757l-1.013.886a1.5 1.5 0 1 1-1.975-2.258l2.988-2.614v-3.793l-3.285 1.896-.77 3.895a1.5 1.5 0 0 1-2.943-.582l.26-1.32-.655.379a2 2 0 1 1-2-3.464l.656-.378-1.273-.434a1.5 1.5 0 0 1 .967-2.84l3.758 1.28L12.027 16l-3.285-1.896-3.758 1.28a1.5 1.5 0 1 1-.967-2.84l1.273-.434-.656-.378a2 2 0 1 1 2-3.464l.656.378-.261-1.32a1.5 1.5 0 0 1 2.943-.581l.77 3.895 3.285 1.896V8.743L11.039 6.13a1.5 1.5 0 1 1 1.975-2.258l1.013.886V4a2 2 0 0 1 2-2" />
  </svg>
);
const ForwardRef = forwardRef(IconCoolingFilledSVG);
ForwardRef.displayName = "IconCoolingFilled";
export { ForwardRef as IconCoolingFilled };
